/* ============================================================
   collection.js — filteren en sorteren zonder de pagina te herladen.

   Het formulier (#Facets) werkt zonder JavaScript: het post naar de collectie-URL
   en Shopify filtert server-side. Dit script onderschept dat alleen, haalt de
   sectie opnieuw op met de Section Rendering API en vervangt het raster. Zo blijft
   de filterlogica bij Shopify en staat er geen tweede versie in JavaScript.

   De URL wordt bijgewerkt met history.pushState: een gefilterde weergave moet je
   kunnen delen en met de terugknop kunnen verlaten.
   ============================================================ */
(() => {
  const form = document.querySelector('#Facets');
  const wortel = document.querySelector('.js-facets');
  if (!form || !wortel) return;

  const sectieId = wortel.closest('.shopify-section')?.id?.replace('shopify-section-', '');
  let bezig = null;

  async function ververs(url, push = true) {
    bezig?.abort();
    bezig = new AbortController();
    wortel.setAttribute('aria-busy', 'true');
    try {
      const antwoord = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=${sectieId}`,
        { signal: bezig.signal });
      const tekst = await antwoord.text();
      const nieuw = new DOMParser().parseFromString(tekst, 'text/html');
      const nieuweWortel = nieuw.querySelector('.js-facets');
      if (nieuweWortel) wortel.innerHTML = nieuweWortel.innerHTML;
      if (push) window.history.pushState({}, '', url);
      koppel();
      // Naar de bovenkant van het raster, niet van de pagina: de filters blijven
      // dan in beeld en je ziet meteen wat er veranderd is.
      wortel.scrollIntoView({ block: 'start', behavior: 'smooth' });
    } catch (e) {
      if (e.name !== 'AbortError') window.location.href = url;   // dan maar ouderwets
    } finally {
      wortel.removeAttribute('aria-busy');
    }
  }

  function urlVanFormulier() {
    const f = document.querySelector('#Facets');
    const data = new FormData(f);
    const params = new URLSearchParams();
    for (const [sleutel, waarde] of data.entries()) {
      if (waarde) params.append(sleutel, waarde);
    }
    const basis = window.location.pathname;
    return params.toString() ? `${basis}?${params}` : basis;
  }

  function koppel() {
    const f = document.querySelector('#Facets');
    if (!f) return;
    f.addEventListener('submit', (e) => { e.preventDefault(); ververs(urlVanFormulier()); });
    f.querySelectorAll('input[type="checkbox"], select').forEach((veld) =>
      veld.addEventListener('change', () => ververs(urlVanFormulier())));
    document.querySelectorAll('.js-facets-active a').forEach((link) =>
      link.addEventListener('click', (e) => { e.preventDefault(); ververs(link.getAttribute('href')); }));
  }

  window.addEventListener('popstate', () => ververs(window.location.href, false));
  koppel();
})();
